import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
  HostListener,
  inject,
  ElementRef,
  OnChanges,
  SimpleChanges
} from '@angular/core'
import { DropDownEntry } from './drop-down-entry.model'
import { EditComponent } from '../../../../components/edit-components/edit-component'

@Component({
  selector: 'jml-lib-wizard-drop-down',
  templateUrl: './wizard-drop-down.component.html',
  styleUrls: ['./wizard-drop-down.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WizardDropDownComponent extends EditComponent implements OnInit {
  @Input() options: DropDownEntry[] = []
  @Input() hideLabel = false
  @Input() hideIcon = false
  @Input() hideAbbr = false
  @Input() hideTooltip = false
  @Input() placeholder: string | undefined = undefined
  @Input() width: string | undefined = undefined
  @Input() appendTo: string | undefined = 'body'
  @Input() showDelete = false
  @Input() field: string

  filteredOptions: DropDownEntry[]

  private valueCacheId: number | null = null
  private isFocused = false

  elementRef = inject(ElementRef)

  ngOnInit() {
    this.filteredOptions = [...this.options]
  }

  getFilteredOptions(event: any): void {
    // console.log('getFilteredOptions', event.query)
    if (!event.query) {
      this.filteredOptions = [...this.options]
    } else {
      const filterValue = event?.query.toLowerCase()

      // Step 1: Get all entries where the filterValue is included in the searchStr property
      const filteredEntries = this.options.filter((entry) => entry.name.toLowerCase().includes(filterValue))

      // Step 2: Check if there is exactly one entry where the filterValue equals abbr
      const exactAbbrMatch = this.options.find((entry) => entry.abbr?.toLowerCase() === filterValue)

      if (exactAbbrMatch) {
        // If exactly one entry matches abbr, return only that one
        this.filteredOptions = [exactAbbrMatch]
      } else {
        // Otherwise, return the filtered entries from step 1
        this.filteredOptions = filteredEntries
      }
    }
  }

  onClickDelete() {
    this.control.setValue(null)
    this.onSelect(null)
  }

  onSelect(selectedEntry: DropDownEntry | null) {
    // console.log("onSelect", selectedEntry);
    if (selectedEntry?.id !== this.valueCacheId) {
      this.valueCacheId = selectedEntry?.id
      this.emitUpdate()
    }
  }

  // Flag is only evaulated onOutsideClick()
  // It will also be reset only there
  // Note: Do not reset isFocused in handleBlur! This will break the logic!
  handleFocus() {
    this.isFocused = true
    this.valueCacheId = this.control.value?.id
  }

  // fires when hitting TAB, clicking outside and also when clicking the drop down button
  handleBlur() {
    if (this.filteredOptions.length === 0) {
      // If the user types a value with no matches leaves with TAB nothing should be selected.
      // Note: if there are matches, TAB will select the one which is selected.
      this.onSelect(null)
    }
  }

  // handles the dropdown behaviour when the user clicks outside
  onOutsideClick() {
    if (this.isFocused) {
      if (this.filteredOptions.length === 0) {
        // If the user types a value with no matches and the user clicks outside nothing should be selected.
        this.onSelect(null)
      } else if (this.filteredOptions.length === 1) {
        // If there is exactly one match and the user clicks outside this match should be selected.
        this.control.setValue(this.filteredOptions[0])
        this.onSelect(this.filteredOptions[0])
      } else if (this.filteredOptions.length === 2) {
        // if there are multiple matches and the user clicks outside nothing should be selected
        this.onSelect(null)
      }
      this.isFocused = false
    }
  }

  @HostListener('document:click', ['$event.target'])
  clickedOutsideControl(target: HTMLElement) {
    if (!this.elementRef.nativeElement.contains(target)) {
      this.onOutsideClick()
    }
  }
}
